/** The potential jobs.
 * Keep in sync with the [EnumMember(Value = "Some Descriptive Value"] of the
 * corresponding JobType enum in Omnius.Custom.Framework.Jobs
 * 
 * If job or export enums are needed to be ran or displayed in V1 then all properties should be updated in Omnius.Framework/Jobs/JobType.cs,
 * otherwise V1 updates can be skipped.
 */
enum JobType {
  NYSDOHProject = "NYSDOH Project",
  ProviderSetGeocode = "ProviderSet Geocode",
  StandardizeNames = "ProviderSet Name Standardization",
  CACDIProject = "CACDI Project",
  CADMHCProject = "CADMHC Project",
  NJDOBIProject = "NJDOBI Project",
  UpdateDeacNPIs = "Update Deactivated NPIs",
  NYSDOHMarket = "NYSDOH Market Analysis",
  NYSDOHRunProjects = "NYSDOH Run Projects",
  NYSDOHMarketDataExtract = "NYSDOH Market Data Extract",
  NJDOBIMarket = "NJDOBI Market",
  NJDOBIRunProjects = "NJDOBI Run Projects",
  NJDOBIMarketDataExtract = "NJDOBI Market Data Extract",
  DailyStatsEmail = "Send Daily Stats Email",
  DeletePurgedProjects = "Delete Purged Projects",
  NYSDOHCreateSpecialtyBridgeTable = "NYSDOH Create Specialty Bridge",
  AmeritasFileImport = "Ameritas File Import",
  AmeritasIndexUpdate = "Ameritas Index Update",
  GenerateMADownloadReport = "Generate Download Report",
  ReportNotification = "Download Report Notification",
  PurgeOldReports = "Purge Old Reports",
  GenerateNYSDOHDownloadReport = "Generate NYSDOH Download Report",
  GenerateNJDOBIDownloadReport = "Generate NJDOBI Download Report",
  GenerateCACDIDownloadReport = "Generate CACDI Download Report",
  GenerateCADMHCDownloadReport = "Generate CADMHC Download Report",
  ProviderSetFormat = "Provider Set Format",
  NYSDOHDownstreamProject = "NYSDOH Downstream Project",
  ProviderSetConversion = "Provider Set Conversion",
  NJDOBIDownstreamProject = "NJDOBI Downstream Project",
  NYSDOHPopulateSpecialtyBridge = "NYSDOH Populate Specialty Bridge",
  NYSDOHDownstreamPopulateSpecialtyBridge = "NYSDOH Downstream Populate Specialty Bridge",
  NJDMAHSProject = "NJDMAHS Project",
  GenerateNJDMAHSDownloadReport = "Generate NJDMAHS Download Report",
  ReviseProjects = "Revise Projects",
  PublishProject = "Publish Project",
  CreateProviderSetIndexes = "Create ProviderSet Indexes",
  CustomAdequacyProject = "Custom Adequacy",
  CustomAdequacyRegionSummary = "Custom Adequacy Region Summary",
  CustomAdequacyProjectReaggregation = "Custom Adequacy Project Reaggregation",
  CustomNetworkSummariesProject = "Custom Network Summaries",
  CustomMemberCensusBlowout = "Custom Member Census Blowout",
  Export = "Export",
  NetworkAccuracyAnalysis = "Network Accuracy Analysis",
  Import = "Import",
  SaveClientGapLinks = "Save Client Gap Links",
  TARSExport = "TARS Export",
  ProcessProviderChanges = "Process Provider Changes",
  SpecialtyGroupExceptionAnalysis = "Specialty Group Exception Analysis",
  QESIProviderUpload = "QESI Provider Upload",
  ProviderChangesRegionSummary = "Provider Changes Region Summary",
  BulkProviderTermination = "Volume Provider Termination",
  AccessReport = "Access Report",
  ProspectMarketNcp = "Prospect/Market Next Closest Provider",
  ProspectMarketNcpRegion = "Prospect/Market Next Closest Provider Region",
  AccuracyGapAnalysis = "Accuracy Gap Analysis",
  BulkTarget = "Volume Target",
  AccessReportEmployeeUpload = "Access Report Employee File Upload",
  AccessReportProviderSetCopy = "Access Report Provider Set Copy",
  MipsDataManagement = "MIPS Import and Data Management",
  PcaDataManagement = "PCA Import and Data Management",
  ValidNPIDataManagement = "Valid NPI Import and Data Management",
  VolumeExport = "Volume Export",
  AccessReportFileShareMaint = "Access Report File Share Maint",
  AccuracyGapAnalysisRegionSummaryJob = "Accuracy Gap Analysis Region Summary Job",
  AccuracyGapAnalysisAggregationJob = "Accuracy Gap Analysis Aggregation Job",
  LocationConfidenceScoresDataManagement = "Location Confidence Scores Import and Data Management",
  CustomCreateProviderSetIndexes = "Custom Create ProviderSet Indexes",
  EnterpriseComplianceDashboard = "Enterprise Compliance Dashboard",
  SimulateNoHeartbeatJob = "Simulate No Heartbeat Job",
  SimulateZombieJob = "Simulate Zombie Job",
  PciDashboardTablePublish = "Provider Claims Insights Dashboard Table Publish",
  AccuracyAggregation = "Accuracy Aggregation",
  PcaDataIngestion = "PCA Data Ingestion",
  ProjectPublishBackgroundJob = "Project Publish Background Job",
  LocationConfidenceScoresDataIngestion = "Location Confidence Scores Data Ingestion",
  SimulateOutOfMemoryJob = "Simulate Out of Memory Job",
  ZipCodeAnalysisProjectRunConfigurationJob = "Zip Code Analysis Project Run Configuration Job",
  ZipCodeAnalysisFinalizerJob = "Zip Code Analysis Finalizer Job",
  ZipCodeAnalysisRegionJob = "Zip Code Analysis Region Job",
  MotiveScoresDataManagement = "Motive Scores Import and Data Management",
  MotiveScoresDataIngestion = "Motive Scores Data Ingestion",
  NetworkBenchmarkingCmsDataIngestion = "Network Benchmarking CMS Data Ingestion",
  NetworkBenchmarkingDefactoDataIngestion = "Network Benchmarking Defacto Data Ingestion",
  NetworkBenchmarkingPciDataIngestion = "Network Benchmarking PCI Data Ingestion",
  CustomCreateNPIInspectionDetailsSummary = "Create NPI Inspection Details Summary Job",
  NetworkBenchmarkingServicingProviderIngestion = "Network Benchmarking Servicing Provider Ingestion",
  NetworkBenchmarkingServicingProviderSplit = "Network Benchmarking Servicing Provider Split",
  ZipClassAggregateJob = "Zip Class Aggregate Job",
  ZipCodeGeographyJob = "Zip Code Geography Job",
  ZipCodeAnalysisCleanExpiredStagingTablesJob = "Zip Code Analysis Clean Expired Staging Tables Job",
  LocationConfidenceScoresActivate = "Location Confidence Scores Activate",
  LocationConfidenceScoresDeactivate = "Location Confidence Scores Deactivate",
  PcaDataActivate = "PCA Data Activate",
  PcaDataDeactivate = "PCA Data Deactivate",
  MipsDataActivate = "MIPS Data Activate",
  MipsDataDeactivate = "MIPS Data Deactivate",
  MotiveScoresActivate = "Motive Scores Activate",
  MotiveScoresDeactivate = "Motive Scores Deactivate",
  ValidNPIDataActivate = "Valid NPI Activate",
  ValidNPIDataDeactivate = "Valid NPI Deactivate",
  SpecialtyGroupDataSync = "Specialty Group Data Sync",
  ProviderValidation = "Provider Validation",
  NetworkIntegrity = "Network Integrity",
  AccuracySummaryAggregation = "Accuracy Summary Aggregation",
  ECDPurgeData = "ECD Purge Data",
  CareJourneyScoresDataManagement = "CareJourneyScores Data Management",
  JobsPurgeData = "Jobs Purge Data",
  ProviderAffiliationVersion = "Provider Affiliation Version Job",
  EcdRunConfigurationsPublished = "ECD Run Configurations Published"
}

export { JobType };